module.exports = __webpack_public_path__ + "d7620b14a001f9eee01c972c4fe3db67.svg";